import { useCallback, useRef, useState } from "react";

export const useExclusiveAction = <Args extends unknown[]>(
  action: (...args: Args) => Promise<void>,
): [run: (...args: Args) => Promise<void>, isRunning: boolean] => {
  const inFlight = useRef(false);
  const [isRunning, setIsRunning] = useState(false);

  const run = useCallback(
    async (...args: Args) => {
      if (inFlight.current) return;
      inFlight.current = true;
      setIsRunning(true);
      try {
        await action(...args);
      } finally {
        inFlight.current = false;
        setIsRunning(false);
      }
    },
    [action],
  );

  return [run, isRunning];
};
